import { useEventConfig } from '@/eventConfig/useEventConfig';
import React, { useState, FC, ChangeEventHandler } from 'react';

interface Props {
  setIsLocked: (param: boolean) => void;
  sidePanelVisible: boolean;
}

export const PinPrompt: FC<Props> = ({ setIsLocked, sidePanelVisible }) => {
  const [falseInput, setFalseInput] = useState(false);
  const { eventConfig } = useEventConfig();
  const pin = eventConfig?.meta?.pin ?? 2805;
  const handleInput: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (!sidePanelVisible) {
      return;
    }
    setFalseInput(false);
    if (pin) {
      // check input against pin from config
      if (e.target.value === pin.toString()) {
        // unset locked state
        setIsLocked(false);
      }
    }
  };
  return (
    <div className="pin" role="form" aria-label="PIN entry form">
      <label htmlFor="pin">Enter PIN:</label>
      <input
        className={falseInput ? 'invalid' : ''}
        id="pin"
        placeholder="PIN"
        type="password"
        onChange={handleInput}
        disabled={!sidePanelVisible}
        tabIndex={sidePanelVisible ? 0 : -1}
        aria-disabled={!sidePanelVisible}
      />
    </div>
  );
};
